/* eslint-disable react/require-default-props */
import React from 'react';
import { CustomSearches } from 'services/actions/custom_search';
import {
  FiltersTypes,
  OnlineSearchState,
  OnlineSearchTypes,
} from 'store/modules/online_search_store/types';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { Container } from './styles';

interface CustomSearchesItemProps {
  searches: CustomSearches[];
  origin?: string;
  onEdit?: (search: CustomSearches) => void;
  onDelete?: (search: CustomSearches) => void;
}

const CustomSearchesItem: React.FC<CustomSearchesItemProps> = ({
  searches,
  origin,
  onEdit,
  onDelete,
}) => {
  const dispatch = useDispatch();
  const { onlineSearch } = useSelector<ApplicationState, OnlineSearchState>(
    (state) => state.session.onlineSearch,
  );

  const handleFilter = (search: CustomSearches) => {
    dispatch({ type: OnlineSearchTypes.CLEAR_FILTER });

    Object.keys(search.filters).forEach((field) => {
      if (field === 'ia_chat_history') return;
      dispatch({
        type: OnlineSearchTypes.CHANGE_VALUE,
        field,
        value: search.filters[field as keyof FiltersTypes],
      });
    });

    dispatch({
      type: OnlineSearchTypes.FILTER_ACTIVE,
      filterActive: { id: search.id, name: search.name },
    });
    dispatch({ type: OnlineSearchTypes.UPDATE_CURRENT_PAGE, currentPage: 1 });
    dispatch({
      type: OnlineSearchTypes.CHANGE_VALUE,
      field: 'updated',
      value: !onlineSearch.filters.updated,
    });
  };

  return (
    <Container>
      <h6>{origin === 'bulletin' ? 'Filtros Salvos:' : 'Pesquisas salvas:'}</h6>
      <div className="searches-list">
        {searches.map((search) => {
          const isActive = onlineSearch.filterActive.id === search.id;
          const isAi = String(search.ai) === 'true';
          return (
            <div className={`search-chip ${isActive ? 'active' : ''}`} key={search.id}>
              <button
                type="button"
                className={`search-chip-name ${isAi ? 'btn-ia' : ''}`}
                onClick={() => handleFilter(search)}
              >
                {search.name}
              </button>
              {isActive && onEdit && (
                <button
                  type="button"
                  className={`search-chip-action ${isAi ? 'btn-teste' : ''}`}
                  title="Editar filtro"
                  onClick={() => onEdit(search)}
                >
                  <i className="material-icons">edit</i>
                </button>
              )}
              {isActive && onDelete && (
                <button
                  type="button"
                  className={`search-chip-action ${isAi ? 'btn-teste' : ''}`}
                  title="Excluir pesquisa"
                  onClick={() => onDelete(search)}
                >
                  <i className="material-icons">delete</i>
                </button>
              )}
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default CustomSearchesItem;
